<script setup>
import uaHeart from '@/assets/icons/ua-heart.svg'

const menuOptions = ref(null)

onMounted(() => {
    menuOptions.value = setMenuOptions()
})
function setMenuOptions() {
    const offer = document.getElementById('expanded-menu-offer')
    const devices = document.getElementById('expanded-menu-devices')
    const clients = document.getElementById('expanded-menu-clients')
    return {
        offer,
        devices,
        clients,
    }
}

let openedMenu = null

function expandMenu(name) {
    const menuList = menuOptions.value[name]
    if (!menuList) {
        return
    }

    if (openedMenu && menuList !== openedMenu) {
        openedMenu.classList.remove('block')
        openedMenu.classList.add('hidden')
    }

    if (menuList.classList.contains('hidden')) {
        menuList.classList.remove('hidden')
        menuList.classList.add('block')
        openedMenu = menuList
        return
    }

    menuList.classList.remove('block')
    menuList.classList.add('hidden')
    openedMenu = null
}

let menuSteps = {}
function toggleMenuPanel(id) {
    const menuPanel = document.getElementById(id)

    if (!menuPanel) {
        console.log('not')
        return
    }

    if (!Object.keys(menuSteps).length) {
        toggleMenuIcon('open')
    }

    if (Object.keys(menuSteps).length && id === 'mobile-menu-step-1') {
        Object.keys(menuSteps)
            .reverse()
            .forEach((_id, index) => {
                const panel = document.getElementById(_id)

                if (index === 0) {
                    panel.style.animation = 'slideLeave .4s ease'
                    setTimeout(() => {
                        panel.classList.add('hidden')
                    }, 390)
                } else {
                    panel.classList.add('hidden')
                }
            })

        menuSteps = {}
        toggleMenuIcon('close')

        return
    }

    if (menuSteps[id]) {
        delete menuSteps[id]

        menuPanel.style.animation = 'slideLeave .4s ease'
        setTimeout(() => {
            menuPanel.classList.add('hidden')
        }, 390)

        if (!Object.keys(menuSteps).length) {
            toggleMenuIcon('close')
        }
        return
    }

    menuPanel.classList.remove('hidden')
    menuPanel.style.animation = 'slideFrom .4s ease'

    menuSteps[id] = menuPanel
}

function toggleMenuIcon(action) {
    const menuIcon = document.getElementById('menu-icon')
    if (action === 'close') {
        menuIcon.classList.remove('close')
        menuIcon.classList.add('open')
        document.body.classList.remove('overflow-hidden')
        return
    }

    menuIcon.classList.remove('open')
    menuIcon.classList.add('close')
    document.body.classList.add('overflow-hidden')
}
</script>

<template>
    <header class="z-[99] md:relative">
        <div
            id="mobile"
            class="border-b border-[#eee] bg-white md:hidden"
        >
            <div>
                <div class="flex items-center justify-between px-3 py-4">
                    <div class="flex items-center gap-12">
                        <a
                            href="https://www.plus.pl"
                            class="max-w-[110px]"
                        >
                            <img
                                src="https://api.plus.pl/jcr/files/file/adp/files/images_lp/plus/logo.svg"
                                alt="Plus"
                                aria-label="Logo plusa"
                            />
                        </a>
                    </div>

                    <div class="flex items-center gap-6">
                        <button
                            class="flex flex-col items-center"
                            @click="toggleMenuPanel('mobile-menu-step-1')"
                        >
                            <div
                                id="menu-icon"
                                class="menu-icon open relative"
                            >
                                <span class="menu-icon__line" />
                            </div>
                            <span class="text-xs font-semibold">MENU</span>
                        </button>
                    </div>
                </div>
            </div>

            <!-- MOBILE: STEP-1 -->
            <div
                id="mobile-menu-step-1"
                class="absolute inset-x-0 z-[901] hidden min-h-screen bg-white"
            >
                <ul class="flex flex-col font-semibold">
                    <li class="menu_item">
                        <button
                            class="menu_item_child"
                            @click="toggleMenuPanel('mobile-menu-step-2-offer')"
                        >
                            <p>Oferta</p>
                            >
                        </button>
                    </li>
                    <li class="menu_item">
                        <button
                            class="menu_item_child"
                            @click="toggleMenuPanel('mobile-menu-step-2-devices')"
                        >
                            <p>Telefony i urządzenia</p>
                            >
                        </button>
                    </li>
                    <li class="menu_item">
                        <button
                            class="menu_item_child"
                            @click="toggleMenuPanel('mobile-menu-step-2-clients')"
                        >
                            <p>Obsługa klienta</p>
                            >
                        </button>
                    </li>
                    <li class="menu_item">
                        <a
                            href="https://www.plus.pl/abonament/przedluz-umowe"
                            class="menu_item_child"
                        >
                            Przedłuż umowę
                        </a>
                    </li>
                    <li class="menu_item">
                        <a
                            href="https://www.plus.pl/iplus"
                            class="menu_item_child"
                        >
                            Pobierz aplikację iPlus
                        </a>
                    </li>
                    <li class="menu_item">
                        <a
                            href="https://www.plus.pl/ua"
                            class="menu_item_child flex-wrap !justify-start gap-2"
                        >
                            <img
                                :src="uaHeart"
                                alt="Ukraina serce"
                                aria-label="Serce z flagą ukrainy"
                                loading="lazy"
                            />
                            Пропозиція
                        </a>
                    </li>
                    <li class="menu_item">
                        <a
                            href="https://www.plus.pl/blog/"
                            class="menu_item_child"
                        >
                            Plus Blog
                        </a>
                    </li>
                    <li class="menu_item flex flex-wrap px-3 py-4 text-sm">
                        <p>Przejdź do:</p>
                        <a
                            href="https://www.plus.pl/dla-firm"
                            class="px-2 text-[#024f27] underline hover:no-underline"
                            >Małe firmy</a
                        >
                        <a
                            href="https://www.biznes.plus.pl/"
                            class="px-2 text-[#024f27] underline hover:no-underline"
                            >Średnie i duże firmy</a
                        >
                    </li>
                </ul>
            </div>

            <!-- MOBILE: STEP 2 - OFERTA -->
            <div
                id="mobile-menu-step-2-offer"
                class="absolute inset-x-0 z-[902] hidden min-h-screen bg-white"
            >
                <button
                    class="menu_back_btn"
                    @click="toggleMenuPanel('mobile-menu-step-2-offer')"
                >
                    < Oferta
                </button>
                <ul class="flex flex-col font-semibold">
                    <li class="menu_item">
                        <button
                            class="menu_item_child"
                            @click="toggleMenuPanel('mobile-menu-step-2-offer-step-3-phone')"
                        >
                            <p>Telefoniczna</p>
                            >
                        </button>
                    </li>
                    <li class="menu_item">
                        <button
                            class="menu_item_child"
                            @click="toggleMenuPanel('mobile-menu-step-2-offer-step-3-internet')"
                        >
                            <p>Internetowa</p>
                            >
                        </button>
                    </li>
                    <li class="menu_item">
                        <button
                            class="menu_item_child"
                            @click="toggleMenuPanel('mobile-menu-step-2-offer-step-3-tv')"
                        >
                            <p>Telewizyjna</p>
                            >
                        </button>
                    </li>
                    <li class="menu_item">
                        <button
                            class="menu_item_child"
                            @click="toggleMenuPanel('mobile-menu-step-2-offer-step-3-smartdom')"
                        >
                            <p>Usługi Łączone</p>
                            >
                        </button>
                    </li>
                    <li class="menu_item">
                        <button
                            class="menu_item_child"
                            @click="toggleMenuPanel('mobile-menu-step-2-offer-step-3-services')"
                        >
                            <p>Usługi</p>
                            >
                        </button>
                    </li>
                </ul>
            </div>

            <!-- MOBILE: STEP 2 - URZĄDZENIA -->
            <div
                id="mobile-menu-step-2-devices"
                class="absolute inset-x-0 z-[902] hidden min-h-screen bg-white"
            >
                <button
                    class="menu_back_btn"
                    @click="toggleMenuPanel('mobile-menu-step-2-devices')"
                >
                    < Telefony i urządzenia
                </button>
                <ul class="flex flex-col font-semibold">
                    <li class="menu_item">
                        <button
                            class="menu_item_child"
                            @click="toggleMenuPanel('mobile-menu-step-2-devices-step-3-phones')"
                        >
                            <div class="flex flex-col items-start">
                                <p>Telefony</p>
                                <span class="text-sm">Z abonamentem, na raty 0%, za gotówkę</span>
                            </div>
                            >
                        </button>
                    </li>
                    <li class="menu_item">
                        <button
                            class="menu_item_child"
                            @click="toggleMenuPanel('mobile-menu-step-2-devices-step-3-devices')"
                        >
                            <div class="flex flex-col items-start">
                                <p>Urządzenia</p>
                                <span class="text-sm">Modemy, tablety, laptopy, smartsprzęty</span>
                            </div>
                            >
                        </button>
                    </li>
                </ul>

                <div class="border-t border-[#eee] px-3 py-4">
                    <aside class="liberty w-full">
                        <div class="liberty__sticker">Nowość</div>
                        <div>
                            <p class="text-md max-w-[139px] leading-5">
                                Najlepsze telefony za <b class="text-[#13fb76]">gotówkę</b>
                            </p>
                            <p class="mt-4 flex items-center gap-1 text-[10px] leading-[1.2]">
                                od:
                                <img
                                    src="https://api.plus.pl/file/files/file/images_lp/plus/bannery/liberty/tablet_Liberty_nowe_logo_poziom_na_bieli.webp"
                                    alt="liberty-logo"
                                    loading="lazy"
                                />
                            </p>
                        </div>
                        <a
                            href="https://liberty.eu/bez-abonamentu/telefony"
                            target="_blank"
                            class="liberty__btn"
                        >
                            >
                        </a>
                    </aside>
                </div>

                <div class="px-3">
                    <p class="mb-4">
                        <strong>Strefa marek:</strong>
                    </p>
                    <ul class="mb-8 grid grid-cols-2 gap-2 font-semibold">
                        <li>
                            <a
                                href="https://www.plus.pl/strefa-dobrych-sprzetow/samsung"
                                class="flex h-12 items-center justify-center border border-[#eee] p-2"
                            >
                                <img
                                    src="https://api.plus.pl/jcr/files/file/adp/files/images_lp/plus/menu/samsung.webp"
                                    alt="Samsung logo"
                                    loading="lazy"
                                />
                            </a>
                        </li>
                        <li>
                            <a
                                href="https://www.plus.pl/strefa-apple"
                                class="flex h-12 items-center justify-center border border-[#eee] p-2"
                            >
                                <img
                                    src="https://api.plus.pl/file/files/file/images_lp/plus/menu/Apple1.webp"
                                    alt="Apple logo"
                                    loading="lazy"
                                />
                            </a>
                        </li>
                        <li>
                            <a
                                href="https://www.plus.pl/strefa-dobrych-sprzetow/huawei"
                                class="flex h-12 items-center justify-center border border-[#eee] p-2"
                            >
                                <img
                                    src="https://api.plus.pl/jcr/files/file/adp/files/images_lp/plus/menu/huawei.webp"
                                    alt="Huawei logo"
                                    loading="lazy"
                                />
                            </a>
                        </li>
                        <li>
                            <a
                                href="https://www.plus.pl/strefa-dobrych-sprzetow/oppo"
                                class="flex h-12 items-center justify-center border border-[#eee] p-2"
                            >
                                <img
                                    src="https://api.plus.pl/jcr/files/file/adp/files/images_lp/plus/menu/oppo.webp"
                                    alt="Oppo logo"
                                    loading="lazy"
                                />
                            </a>
                        </li>
                        <li>
                            <a
                                href="https://www.plus.pl/strefa-dobrych-sprzetow/xiaomi"
                                class="flex h-12 items-center justify-center border border-[#eee] p-2"
                            >
                                <img
                                    src="https://api.plus.pl/jcr/files/file/adp/files/images_lp/plus/menu/xiaomi.webp"
                                    alt="Xiaomi logo"
                                    loading="lazy"
                                />
                            </a>
                        </li>
                        <li>
                            <a
                                href="https://www.plus.pl/strefa-dobrych-sprzetow/motorola"
                                class="flex h-12 items-center justify-center border border-[#eee] p-2"
                            >
                                <img
                                    src="https://api.plus.pl/jcr/files/file/adp/files/images_lp/plus/strefa-dobrych-sprzetow/Motorola_new_logo.svg"
                                    alt="Motorola logo"
                                    loading="lazy"
                                />
                            </a>
                        </li>
                    </ul>

                    <a
                        href="https://www.plus.pl/pluswymiana"
                        class="flex items-center justify-center"
                    >
                        <img
                            src="https://api.plus.pl/file/files/file/images_lp/plus/bannery/menu.webp"
                            alt="Banner iPhone 15 w Programie Plus Wymiana. Teraz za jedyne 3166 zł"
                            loading="lazy"
                        />
                    </a>
                </div>
            </div>

            <!-- MOBILE: STEP 2 - OBSŁUGA KLIENTA -->
            <div
                id="mobile-menu-step-2-clients"
                class="absolute inset-x-0 z-[902] hidden min-h-screen bg-white"
            >
                <button
                    class="menu_back_btn"
                    @click="toggleMenuPanel('mobile-menu-step-2-clients')"
                >
                    < Obsługa klienta
                </button>
                <ul class="flex flex-col font-semibold">
                    <li class="menu_item">
                        <a
                            href="https://www.plus.pl/kontakt/"
                            class="menu_item_child"
                        >
                            Kontakt
                        </a>
                    </li>
                    <li class="menu_item">
                        <button
                            class="menu_item_child"
                            @click="toggleMenuPanel('mobile-menu-step-2-clients-step-3-info')"
                        >
                            <div class="flex flex-col items-start">
                                <p>Przydatne informacje</p>
                                <span class="text-sm">Mapa zasięgu, Pomoc i FAQ, Płatności</span>
                            </div>
                            >
                        </button>
                    </li>
                    <li class="menu_item">
                        <button
                            class="menu_item_child"
                            @click="toggleMenuPanel('mobile-menu-step-2-clients-step-3-clients')"
                        >
                            <div class="flex flex-col items-start">
                                <p>Dla obecnych klientów</p>
                                <span class="text-sm">Doładuj konto, opłać fakturę, krótkie kody</span>
                            </div>
                            >
                        </button>
                    </li>
                    <li class="menu_item">
                        <button
                            class="menu_item_child"
                            @click="toggleMenuPanel('mobile-menu-step-2-clients-step-3-iplus')"
                        >
                            <p>iPlus</p>
                            >
                        </button>
                    </li>
                    <li class="menu_item">
                        <a
                            href="https://www.plus.pl/iplus"
                            class="menu_item_child"
                        >
                            Pobierz aplikację iPlus
                        </a>
                    </li>
                    <li class="menu_item">
                        <a
                            href="https://www.plus.pl/speedtest"
                            class="menu_item_child"
                        >
                            Sprawdź prędkość internetu
                        </a>
                    </li>
                    <li class="menu_item">
                        <a
                            href="https://www.plus.pl/zwroty"
                            class="menu_item_child"
                        >
                            Darmowe zwroty
                        </a>
                    </li>
                </ul>
            </div>

            <!-- STEPS 3 -->
            <!-- MOBILE: STEP 3 - OFERTA - TELEFONICZNA -->
            <div
                id="mobile-menu-step-2-offer-step-3-phone"
                class="absolute inset-x-0 z-[903] hidden min-h-screen bg-white"
            >
                <button
                    class="menu_back_btn"
                    @click="toggleMenuPanel('mobile-menu-step-2-offer-step-3-phone')"
                >
                    < Telefoniczna
                </button>
                <ul class="flex flex-col font-semibold">
                    <li class="menu_item">
                        <a
                            href="https://www.plus.pl/abonament"
                            class="menu_item_child"
                        >
                            Na abonament 5G
                        </a>
                    </li>
                    <li class="menu_item">
                        <a
                            href="https://www.plus.pl/telefon-na-karte"
                            class="menu_item_child"
                        >
                            Na kartę
                        </a>
                    </li>
                    <li class="menu_item">
                        <a
                            href="https://www.plus.pl/telefon_stacjonarny"
                            class="menu_item_child"
                        >
                            Telefon stacjonarny
                        </a>
                    </li>
                    <li class="menu_item">
                        <a
                            href="https://www.plus.pl/mix/nowy-numer"
                            class="menu_item_child"
                        >
                            Zmień MIX na abonament
                        </a>
                    </li>
                    <li class="menu_item">
                        <a
                            href="https://www.plus.pl/abonament/przedluz-umowe"
                            class="menu_item_child"
                        >
                            Przedłuż lub zmień umowę
                        </a>
                    </li>
                </ul>
            </div>

            <!-- MOBILE: STEP 3 - OFERTA - INTERNETOWA -->
            <div
                id="mobile-menu-step-2-offer-step-3-internet"
                class="absolute inset-x-0 z-[903] hidden min-h-screen bg-white"
            >
                <button
                    class="menu_back_btn"
                    @click="toggleMenuPanel('mobile-menu-step-2-offer-step-3-internet')"
                >
                    < Internetowa
                </button>
                <ul class="flex flex-col font-semibold">
                    <li class="menu_item">
                        <a
                            href="https://www.plus.pl/swiatlowod"
                            class="menu_item_child"
                        >
                            Światłowód
                        </a>
                    </li>
                    <li class="menu_item">
                        <a
                            href="https://www.plus.pl/internet-5g"
                            class="menu_item_child"
                        >
                            Internet bezprzewodowy
                        </a>
                    </li>
                    <li class="menu_item">
                        <a
                            href="https://www.plus.pl/zestaw-domowy"
                            class="menu_item_child"
                        >
                            Zestaw domowy
                        </a>
                    </li>
                    <li class="menu_item">
                        <a
                            href="https://www.plus.pl/internet-na-karte"
                            class="menu_item_child"
                        >
                            Na kartę
                        </a>
                    </li>
                    <li class="menu_item">
                        <a
                            href="https://www.plus.pl/internet-5g/przedluz-umowe"
                            class="menu_item_child"
                        >
                            Przedłuż lub zmień umowę
                        </a>
                    </li>
                </ul>
            </div>

            <!-- MOBILE: STEP 3 - OFERTA - TELEWIZYJNA -->
            <div
                id="mobile-menu-step-2-offer-step-3-tv"
                class="absolute inset-x-0 z-[903] hidden min-h-screen bg-white"
            >
                <button
                    class="menu_back_btn"
                    @click="toggleMenuPanel('mobile-menu-step-2-offer-step-3-tv')"
                >
                    < Telewizyjna
                </button>
                <ul class="flex flex-col font-semibold">
                    <li class="menu_item">
                        <a
                            href="https://sklep.polsatbox.pl/telewizja-satelitarna-disney"
                            class="menu_item_child"
                        >
                            Telewizja Polsat Box
                        </a>
                    </li>
                    <li class="menu_item">
                        <a
                            href="https://www.plus.pl/uslugi/ipla"
                            class="menu_item_child"
                        >
                            Telewizja Polsat Box Go
                        </a>
                    </li>
                    <li class="menu_item">
                        <a
                            href="https://www.plus.pl/disney"
                            class="menu_item_child"
                        >
                            Disney+
                        </a>
                    </li>
                    <li class="menu_item">
                        <a
                            href="https://www.plus.pl/max"
                            class="menu_item_child"
                        >
                            MAX
                        </a>
                    </li>
                    <li class="menu_item">
                        <a
                            href="https://www.plus.pl/streaming"
                            class="menu_item_child flex justify-between"
                        >
                            <p>Pakiet streamingów</p>
                            <p class="mx-3 text-[#35a735]">NOWOŚĆ</p>
                        </a>
                    </li>
                </ul>
            </div>

            <!-- MOBILE: STEP 3 - OFERTA - SMARTDOM -->
            <div
                id="mobile-menu-step-2-offer-step-3-smartdom"
                class="absolute inset-x-0 z-[903] hidden min-h-screen bg-white"
            >
                <button
                    class="menu_back_btn"
                    @click="toggleMenuPanel('mobile-menu-step-2-offer-step-3-smartdom')"
                >
                    < Usługi Łączone
                </button>
                <ul class="flex flex-col font-semibold">
                    <li class="menu_item">
                        <a
                            href="https://www.plus.pl/smartdom"
                            class="menu_item_child"
                        >
                            Jak działają usługi łączone??
                        </a>
                    </li>
                    <li class="menu_item">
                        <a
                            href="https://www.plus.pl/zestawy-smartdom"
                            class="menu_item_child"
                        >
                            Internet, telefon oraz telewizja
                        </a>
                    </li>
                </ul>
            </div>

            <!-- MOBILE: STEP 3 - OFERTA - USŁUGI -->
            <div
                id="mobile-menu-step-2-offer-step-3-services"
                class="absolute inset-x-0 z-[903] hidden min-h-screen bg-white"
            >
                <button
                    class="menu_back_btn"
                    @click="toggleMenuPanel('mobile-menu-step-2-offer-step-3-services')"
                >
                    < Usługi
                </button>
                <ul class="flex flex-col font-semibold">
                    <li class="menu_item">
                        <a
                            href="https://www.plus.pl/uslugi/all-in"
                            class="menu_item_child"
                        >
                            Pakiet All In
                        </a>
                    </li>
                    <li class="menu_item">
                        <a
                            href="https://www.plus.pl/uslugi/serwis-urzadzenia"
                            class="menu_item_child"
                        >
                            Serwis urządzenia
                        </a>
                    </li>
                    <li class="menu_item">
                        <a
                            href="https://www.plus.pl/uslugi/gdzie-jest-bliski"
                            class="menu_item_child flex"
                        >
                            stop Hejt
                            <p class="mx-3 text-[#35a735]">NOWOŚĆ</p>
                        </a>
                    </li>
                    <li class="menu_item">
                        <a
                            href="https://www.plus.pl/uslugi"
                            class="menu_item_child"
                        >
                            Usługi i pakiety dodatkowe
                        </a>
                    </li>
                    <li class="menu_item">
                        <a
                            href="https://www.plus.pl/prosumenci"
                            class="menu_item_child"
                        >
                            O prądzie
                        </a>
                    </li>
                    <li class="menu_item">
                        <a
                            href="https://www.plus.pl/lokalizatory"
                            class="menu_item_child flex justify-between"
                        >
                            <p>Lokalizatory</p>
                            <p class="mx-3 text-[#35a735]">NOWOŚĆ</p>
                        </a>
                    </li>
                </ul>
            </div>

            <!-- MOBILE: STEP 3 - TELEFONY I URZĄDZENIA - TELEFONY -->
            <div
                id="mobile-menu-step-2-devices-step-3-phones"
                class="absolute inset-x-0 z-[903] hidden min-h-screen bg-white"
            >
                <button
                    class="menu_back_btn"
                    @click="toggleMenuPanel('mobile-menu-step-2-devices-step-3-phones')"
                >
                    < Telefony i urządzenia
                </button>
                <ul class="flex flex-col font-semibold">
                    <li class="menu_item">
                        <a
                            href="https://www.plus.pl/telefony"
                            class="menu_item_child"
                        >
                            Z abonamentem
                        </a>
                    </li>
                    <li class="menu_item">
                        <a
                            href="https://www.plus.pl/telefony/raty-zero"
                            class="menu_item_child"
                        >
                            Na raty 0%
                        </a>
                    </li>
                    <li class="menu_item">
                        <a
                            href="https://www.plus.pl/plusodkup"
                            class="menu_item_child"
                        >
                            <div class="inline">
                                Plus Odkup<span class="font-light">
                                    - odsprzedaj nam swój smartfon i zyskaj środki na nowy</span
                                >
                            </div>
                        </a>
                    </li>
                    <li class="menu_item">
                        <a
                            href="https://www.plus.pl/pluswymiana"
                            class="menu_item_child"
                        >
                            <div class="inline">
                                Plus Wymiana<span class="font-light"> - nowy iPhone co dwa lata</span>
                            </div>
                        </a>
                    </li>
                </ul>

                <div class="border-t border-[#eee] px-3 py-4">
                    <aside class="liberty w-full">
                        <div class="liberty__sticker">Nowość</div>
                        <div>
                            <p class="text-md max-w-[139px] leading-5">
                                Najlepsze telefony za <b class="text-[#13fb76]">gotówkę</b>
                            </p>
                            <p class="mt-4 flex items-center gap-1 text-[10px] leading-[1.2]">
                                od:
                                <img
                                    src="https://api.plus.pl/file/files/file/images_lp/plus/bannery/liberty/tablet_Liberty_nowe_logo_poziom_na_bieli.webp"
                                    alt="liberty-logo"
                                    loading="lazy"
                                />
                            </p>
                        </div>
                        <a
                            href="https://liberty.eu/bez-abonamentu/telefony"
                            target="_blank"
                            class="liberty__btn"
                        >
                            >
                        </a>
                    </aside>
                </div>
            </div>

            <!-- MOBILE: STEP 3 - TELEFONY I URZĄDZENIA - URZĄDZENIA -->
            <div
                id="mobile-menu-step-2-devices-step-3-devices"
                class="absolute inset-x-0 z-[903] hidden min-h-screen bg-white"
            >
                <button
                    class="menu_back_btn"
                    @click="toggleMenuPanel('mobile-menu-step-2-devices-step-3-devices')"
                >
                    < Urządzenia
                </button>
                <ul class="flex flex-col font-semibold">
                    <li class="menu_item">
                        <a
                            href="https://www.plus.pl/modemy-routery"
                            class="menu_item_child"
                        >
                            Modemy i routery
                        </a>
                    </li>
                    <li class="menu_item">
                        <a
                            href="https://www.plus.pl/smartwatche-opaski/raty-zero"
                            class="menu_item_child"
                        >
                            Smartwatche i opaski
                        </a>
                    </li>
                    <li class="menu_item">
                        <a
                            href="https://www.plus.pl/hulajnogi/raty-zero"
                            class="menu_item_child"
                        >
                            Hulajnogi i rowery
                        </a>
                    </li>
                    <li class="menu_item">
                        <a
                            href="https://www.plus.pl/oczyszczacze/raty-zero"
                            class="menu_item_child"
                        >
                            Oczyszczacze
                        </a>
                    </li>
                    <li class="menu_item">
                        <a
                            href="https://www.plus.pl/tablety-laptopy/raty-zero"
                            class="menu_item_child"
                        >
                            Tablety i laptopy
                        </a>
                    </li>
                    <li class="menu_item">
                        <a
                            href="https://www.plus.pl/smart-sprzet/raty-zero"
                            class="menu_item_child"
                        >
                            Telewizory
                        </a>
                    </li>
                    <li class="menu_item">
                        <button
                            class="menu_item_child"
                            @click="toggleMenuPanel('mobile-menu-step-2-devices-step-3-devices-step-4-accessories')"
                        >
                            <p>Akcesoria</p>
                            >
                        </button>
                    </li>
                    <li class="menu_item">
                        <a
                            href="https://www.plus.pl/wzmacniacze-wifi"
                            class="menu_item_child"
                        >
                            Wzmacniacze wi-fi
                        </a>
                    </li>
                    <li class="menu_item">
                        <a
                            href="https://www.plus.pl/cenniki-urzadzen"
                            class="menu_item_child"
                        >
                            Cennik urządzeń
                        </a>
                    </li>
                </ul>
            </div>

            <!-- MOBILE: STEP 4 - TELEFONY I URZĄDZENIA - URZĄDZENIA - AKCESORIA -->
            <div
                id="mobile-menu-step-2-devices-step-3-devices-step-4-accessories"
                class="absolute inset-x-0 z-[904] hidden min-h-screen bg-white"
            >
                <button
                    class="menu_back_btn"
                    @click="toggleMenuPanel('mobile-menu-step-2-devices-step-3-devices-step-4-accessories')"
                >
                    < Akcesoria
                </button>
                <ul class="flex flex-col font-semibold">
                    <li class="menu_item">
                        <a
                            href="https://www.plus.pl/akcesoria/sluchawki/raty-zero"
                            class="menu_item_child"
                        >
                            Słuchawki
                        </a>
                    </li>
                    <li class="menu_item">
                        <a
                            href="https://www.plus.pl/akcesoria/opaska-sos/raty-zero"
                            class="menu_item_child"
                        >
                            Opaska SOS
                        </a>
                    </li>
                    <li class="menu_item">
                        <a
                            href="https://www.plus.pl/akcesoria/lokalizatory/raty-zero"
                            class="menu_item_child"
                        >
                            Lokalizatory
                        </a>
                    </li>
                    <li class="menu_item">
                        <a
                            href="https://www.plus.pl/akcesoria/kaski/raty-zero"
                            class="menu_item_child"
                        >
                            Kaski
                        </a>
                    </li>
                    <li class="menu_item">
                        <a
                            href="https://www.plus.pl/akcesoria/konsole/raty-zero"
                            class="menu_item_child"
                        >
                            Konsole
                        </a>
                    </li>
                    <li class="menu_item">
                        <a
                            href="https://www.plus.pl/akcesoria/monitory/raty-zero"
                            class="menu_item_child"
                        >
                            Monitory
                        </a>
                    </li>
                    <li class="menu_item">
                        <a
                            href="https://www.plus.pl/akcesoria/inne/raty-zero"
                            class="menu_item_child"
                        >
                            Inne
                        </a>
                    </li>
                </ul>
            </div>

            <!-- MOBILE: STEP 3 - OBSŁUGA KLIENTA - PRZYDATNE INFORMACJE -->
            <div
                id="mobile-menu-step-2-clients-step-3-info"
                class="absolute inset-x-0 z-[903] hidden min-h-screen bg-white"
            >
                <button
                    class="menu_back_btn"
                    @click="toggleMenuPanel('mobile-menu-step-2-clients-step-3-info')"
                >
                    < Przydatne informacje
                </button>
                <ul class="flex flex-col font-semibold">
                    <li class="menu_item">
                        <a
                            href="https://www.plus.pl/pomoc-faq"
                            class="menu_item_child"
                        >
                            Pomoc i FAQ
                        </a>
                    </li>
                    <li class="menu_item">
                        <a
                            href="https://www.plus.pl/5g"
                            class="menu_item_child"
                        >
                            5G
                        </a>
                    </li>
                    <li class="menu_item">
                        <a
                            href="https://www.plus.pl/mapa-zasiegu"
                            class="menu_item_child"
                        >
                            Mapa zasięgu
                        </a>
                    </li>
                    <li class="menu_item">
                        <a
                            href="https://www.plus.pl/uslugi/platnosci"
                            class="menu_item_child"
                        >
                            Faktury i formy płatności
                        </a>
                    </li>
                </ul>
            </div>

            <!-- MOBILE: STEP 3 - OBSŁUGA KLIENTA - DLA OBECNYCH KLIENTÓW -->
            <div
                id="mobile-menu-step-2-clients-step-3-clients"
                class="absolute inset-x-0 z-[903] hidden min-h-screen bg-white"
            >
                <button
                    class="menu_back_btn"
                    @click="toggleMenuPanel('mobile-menu-step-2-clients-step-3-clients')"
                >
                    < Dla obecnych klientów
                </button>
                <ul class="flex flex-col font-semibold">
                    <li class="menu_item">
                        <a
                            href="https://www.plus.pl/abonament/przedluz-umowe"
                            class="menu_item_child"
                        >
                            Przedłuż umowę
                        </a>
                    </li>
                    <li class="menu_item">
                        <a
                            href="https://doladuj.plus.pl/doladowanie"
                            class="menu_item_child"
                        >
                            Doładuj konto
                        </a>
                    </li>
                    <li class="menu_item">
                        <a
                            href="https://plus.pl/platnosc/"
                            class="menu_item_child"
                        >
                            Opłać fakturę online
                        </a>
                    </li>
                    <li class="menu_item">
                        <a
                            href="https://www.plus.pl/uslugi/krotkie-kody-w-plusie-na-karte"
                            class="menu_item_child"
                        >
                            Krótkie kody (na kartę)
                        </a>
                    </li>
                    <li class="menu_item">
                        <a
                            href="https://www.plus.pl/strefa-plusow"
                            class="menu_item_child"
                        >
                            Bonusy i promocje
                        </a>
                    </li>
                </ul>
            </div>

            <!-- MOBILE: STEP 3 - OBSŁUGA KLIENTA - IPLUS -->
            <div
                id="mobile-menu-step-2-clients-step-3-iplus"
                class="absolute inset-x-0 z-[903] hidden min-h-screen bg-white"
            >
                <button
                    class="menu_back_btn"
                    @click="toggleMenuPanel('mobile-menu-step-2-clients-step-3-iplus')"
                >
                    < iPlus
                </button>
                <ul class="flex flex-col font-semibold">
                    <li class="menu_item">
                        <a
                            href="https://ssl.plusgsm.pl/ebok-web/basic/loginStep1.action?brandId=Postpaid"
                            class="menu_item_child"
                        >
                            Zaloguj się do iPlus
                        </a>
                    </li>
                    <li class="menu_item">
                        <a
                            href="https://www.plus.pl/iplus"
                            class="menu_item_child"
                        >
                            Co to jest iPlus?
                        </a>
                    </li>
                </ul>
            </div>
        </div>

        <!-- DESKTOP -->
        <div
            id="desktop-menu"
            class="sticky top-0 hidden bg-white md:block"
        >
            <div class="relative z-[1050] mx-auto max-w-screen-xl border-b border-[#eee] bg-white px-3">
                <div class="flex justify-end gap-3 text-sm tracking-tight">
                    <ul class="flex gap-3 border-r border-[#cacaca] pr-3">
                        <li><a href="https://www.plus.pl/">Klienci indywidualni</a></li>
                        <li>
                            <a href="https://www.plus.pl/dla-firm/telefony-i-urzadzenia-e/telefony-i-smartfony"
                                >Małe firmy</a
                            >
                        </li>
                        <li><a href="https://biznes.plus.pl">Średnie i duże firmy</a></li>
                    </ul>

                    <a
                        href="https://ssl.plusgsm.pl/ebok-web/basic/loginStep1.action?brandId=Postpaid"
                        class="font-semibold"
                    >Zaloguj do iPlus</a
                    >
                </div>
                <div class="flex justify-between py-4">
                    <div class="flex items-center gap-12">
                        <a
                            href="https://www.plus.pl"
                            class="max-w-[120px]"
                        >
                            <img
                                src="https://api.plus.pl/jcr/files/file/adp/files/images_lp/plus/logo.svg"
                                alt="Plus"
                                aria-label="Logo plusa"
                            />
                        </a>

                        <div id="menu-list">
                            <ul class="flex gap-6 font-bold">
                                <li><button @click="expandMenu('offer')">Oferta</button></li>
                                <li><button @click="expandMenu('devices')">Telefony i urządzenia</button></li>
                                <li><button @click="expandMenu('clients')">Obsługa klienta</button></li>
                                <li><a href="https://www.plus.pl/abonament/przedluz-umowe">Przedłuż umowę</a></li>
                                <li>
                                    <a
                                        href="https://www.plus.pl/ua"
                                        class="flex flex-wrap gap-2"
                                    >
                                        <img
                                            :src="uaHeart"
                                            alt="Ukraina serce"
                                            aria-label="Serce z flagą ukrainy"
                                            loading="lazy"
                                        />
                                        Пропозиція
                                    </a>
                                </li>
                                <li><a href="https://www.plus.pl/blog">Plus Blog</a></li>
                            </ul>
                        </div>
                    </div>
                    <div class="flex items-center gap-6">
                        <button>
                            <img
                                src="https://api.plus.pl/file/files/file/images_lp/plus/sg/header/cart.svg"
                                alt="Koszyk"
                            />
                        </button>
                        <a href="https://www.plus.pl/5g">
                            <img
                                src="https://api.plus.pl/file/files/file/images_lp/plus/5G_Ultra.svg"
                                alt="5G"
                                class="w-10"
                            />
                        </a>
                    </div>
                </div>
            </div>

            <!-- ZAKŁADKA: OFERTA -->
            <div
                id="expanded-menu-offer"
                class="absolute inset-x-0 z-[500] hidden min-h-[400px] bg-white py-6 shadow-[0px_3px_26px_rgba(0,0,0,0.1019607843)]"
            >
                <div class="mx-auto grid max-w-screen-xl grid-cols-4 gap-6 px-3 pb-4">
                    <div>
                        <p class="mb-4">
                            <strong>Telefoniczna:</strong>
                        </p>
                        <ul class="grid gap-2 font-semibold">
                            <li><a href="https://www.plus.pl/abonament">Na abonament 5G</a></li>
                            <li><a href="https://www.plus.pl/telefon-na-karte">Na karte</a></li>
                            <li><a href="https://www.plus.pl/telefon_stacjonarny">Telefon stacjonarny</a></li>
                            <li><a href="https://www.plus.pl/mix/nowy-numer">Zmień MIX na abonament</a></li>
                            <li>
                                <a href="https://www.plus.pl/abonament/przedluz-umowe">Przedłuż lub zmień umowę</a>
                            </li>
                            <li><a href="https://www.plus.pl/abonament/zmien-umowe">Zyskaj więcej GB</a></li>
                        </ul>
                    </div>

                    <div>
                        <p class="mb-4">
                            <strong>Internetowa:</strong>
                        </p>
                        <ul class="grid gap-2 font-semibold">
                            <li><a href="https://www.plus.pl/swiatlowod">Światłowód</a></li>
                            <li><a href="https://www.plus.pl/internet-5g">Internet bezprzewodowy</a></li>
                            <li><a href="https://www.plus.pl/zestaw-domowy">Zestaw domowy</a></li>
                            <li><a href="https://www.plus.pl/internet-na-karte">Na kartę</a></li>
                            <li>
                                <a href="https://www.plus.pl/internet-5g/przedluz-umowe">Przedłuż lub zmień umowę</a>
                            </li>
                        </ul>
                    </div>

                    <div>
                        <p class="mb-4">
                            <strong>Telewizyjna:</strong>
                        </p>
                        <ul class="grid gap-2 font-semibold">
                            <li>
                                <a href="https://sklep.polsatbox.pl/telewizja-satelitarna-disney"
                                    >Telewizja Polsat Box</a
                                >
                            </li>
                            <li><a href="https://www.plus.pl/uslugi/ipla">Telewizja Polsat Box Go</a></li>
                            <li><a href="https://www.plus.pl/disney">Disney+</a></li>
                            <li><a href="https://www.plus.pl/max">Max</a></li>
                            <li>
                                <a
                                    href="https://www.plus.pl/streaming"
                                    class="flex"
                                >
                                    Pakiet streamingów
                                    <p class="mx-3 text-[#35a735]">NOWOŚĆ</p>
                                </a>
                            </li>
                        </ul>
                    </div>

                    <div>
                        <p class="mb-4">
                            <strong>Usługi Łączone:</strong>
                        </p>
                        <ul class="grid gap-2 font-semibold">
                            <li><a href="https://www.plus.pl/smartdom">Jak działają usługi łączone?</a></li>
                            <li>
                                <a href="https://www.plus.pl/zestawy-smartdom">Internet, telefon oraz telewizja</a>
                            </li>
                        </ul>

                        <p class="my-4">
                            <strong>Usługi:</strong>
                        </p>
                        <ul class="grid gap-2 font-semibold">
                            <li><a href="https://www.plus.pl/uslugi/all-in">Pakiet All In</a></li>
                            <li>
                                <a
                                    href="https://www.plus.pl/uslugi/serwis-urzadzenia"
                                    class="flex"
                                >
                                    Serwis urządzenia
                                    <p class="mx-3 text-[#35a735]">POLECAMY</p>
                                </a>
                            </li>
                            <li>
                                <a
                                    href="https://www.plus.pl/uslugi/gdzie-jest-bliski"
                                    class="flex"
                                >
                                    stop Hejt
                                    <p class="mx-3 text-[#35a735]">NOWOŚĆ</p>
                                </a>
                            </li>
                            <li><a href="https://www.plus.pl/uslugi">Usługi i pakiety dodatkowe</a></li>
                            <li><a href="https://www.plus.pl/prosumenci">O prądzie</a></li>
                            <li>
                                <a
                                    href="https://www.plus.pl/lokalizatory"
                                    class="flex"
                                >
                                    Lokalizatory
                                    <p class="mx-3 text-[#35a735]">NOWOŚĆ</p>
                                </a>
                            </li>
                            <li><a href="https://www.plus.pl/plus-platnosci">Płatności mobilne</a></li>
                        </ul>
                    </div>
                </div>
            </div>

            <!-- ZAKŁADKA: TELEFONY I URZĄDZENIA -->
            <div
                id="expanded-menu-devices"
                class="absolute inset-x-0 z-[500] hidden min-h-[400px] bg-white py-6 shadow-[0px_3px_26px_rgba(0,0,0,0.1019607843)]"
            >
                <div class="mx-auto grid max-w-screen-xl grid-cols-4 gap-6 px-3 pb-4">
                    <div>
                        <p class="mb-4">
                            <strong>Telefony:</strong>
                        </p>
                        <ul class="grid gap-2 font-semibold">
                            <li><a href="https://www.plus.pl/telefony">Z abonamentem</a></li>
                            <li><a href="https://www.plus.pl/telefony/raty-zero">Na raty 0%</a></li>
                            <li>
                                <a href="https://www.plus.pl/plusodkup"
                                    >Plus Odkup<span class="font-light">
                                        - odsprzedaj nam swój smartfon i zyskaj środki na nowy</span
                                    ></a
                                >
                            </li>
                            <li>
                                <a href="https://www.plus.pl/pluswymiana"
                                    >Plus Wymiana<span class="font-light"> - nowy iPhone co dwa lata</span></a
                                >

                                <aside class="liberty max-w-[280px]">
                                    <div class="liberty__sticker">Nowość</div>
                                    <div>
                                        <p class="text-md max-w-[139px] leading-5">
                                            Najlepsze telefony za <b class="text-[#13fb76]">gotówkę</b>
                                        </p>
                                        <p class="mt-4 flex items-center gap-1 text-[10px] leading-[1.2]">
                                            od:
                                            <img
                                                src="https://api.plus.pl/file/files/file/images_lp/plus/bannery/liberty/tablet_Liberty_nowe_logo_poziom_na_bieli.webp"
                                                alt="liberty-logo"
                                                loading="lazy"
                                            />
                                        </p>
                                    </div>
                                    <a
                                        href="https://liberty.eu/bez-abonamentu/telefony"
                                        target="_blank"
                                        class="liberty__btn"
                                    >
                                        >
                                    </a>
                                </aside>
                            </li>
                        </ul>
                    </div>

                    <div>
                        <p class="mb-4">
                            <strong>Urządzenia:</strong>
                        </p>
                        <ul class="grid gap-2 font-semibold">
                            <li><a href="https://www.plus.pl/modemy-routery">Modemy i routery</a></li>
                            <li>
                                <a href="https://www.plus.pl/smartwatche-opaski/raty-zero">Smartwatche i opaski</a>
                            </li>
                            <li><a href="https://www.plus.pl/hulajnogi/raty-zero">Hulajnogi i rowery</a></li>
                            <li><a href="https://www.plus.pl/oczyszczacze/raty-zero">Oczyszczacze</a></li>
                            <li><a href="https://www.plus.pl/tablety-laptopy/raty-zero">Tablety i laptopy</a></li>
                            <li><a href="https://www.plus.pl/smart-sprzet/raty-zero">Telewizory</a></li>
                            <li><a href="https://www.plus.pl/akcesoria/raty-zero">Akcesoria</a></li>
                            <li><a href="https://www.plus.pl/wzmacniacze-wifi">Wzmacniacze wi-fi</a></li>
                            <li><a href="https://www.plus.pl/cenniki-urzadzen">Cennik urządzeń</a></li>
                        </ul>
                    </div>

                    <div>
                        <p class="mb-4">
                            <strong>Strefa marek:</strong>
                        </p>
                        <ul class="mb-8 grid grid-cols-2 gap-2 font-semibold">
                            <li>
                                <a
                                    href="https://www.plus.pl/strefa-dobrych-sprzetow/samsung"
                                    class="flex h-12 items-center justify-center border border-[#eee] p-2"
                                >
                                    <img
                                        src="https://api.plus.pl/jcr/files/file/adp/files/images_lp/plus/menu/samsung.webp"
                                        alt="Samsung logo"
                                        loading="lazy"
                                    />
                                </a>
                            </li>
                            <li>
                                <a
                                    href="https://www.plus.pl/strefa-apple"
                                    class="flex h-12 items-center justify-center border border-[#eee] p-2"
                                >
                                    <img
                                        src="https://api.plus.pl/file/files/file/images_lp/plus/menu/Apple1.webp"
                                        alt="Apple logo"
                                        loading="lazy"
                                    />
                                </a>
                            </li>
                            <li>
                                <a
                                    href="https://www.plus.pl/strefa-dobrych-sprzetow/huawei"
                                    class="flex h-12 items-center justify-center border border-[#eee] p-2"
                                >
                                    <img
                                        src="https://api.plus.pl/jcr/files/file/adp/files/images_lp/plus/menu/huawei.webp"
                                        alt="Huawei logo"
                                        loading="lazy"
                                    />
                                </a>
                            </li>
                            <li>
                                <a
                                    href="https://www.plus.pl/strefa-dobrych-sprzetow/oppo"
                                    class="flex h-12 items-center justify-center border border-[#eee] p-2"
                                >
                                    <img
                                        src="https://api.plus.pl/jcr/files/file/adp/files/images_lp/plus/menu/oppo.webp"
                                        alt="Oppo logo"
                                        loading="lazy"
                                    />
                                </a>
                            </li>
                            <li>
                                <a
                                    href="https://www.plus.pl/strefa-dobrych-sprzetow/xiaomi"
                                    class="flex h-12 items-center justify-center border border-[#eee] p-2"
                                >
                                    <img
                                        src="https://api.plus.pl/jcr/files/file/adp/files/images_lp/plus/menu/xiaomi.webp"
                                        alt="Xiaomi logo"
                                        loading="lazy"
                                    />
                                </a>
                            </li>
                            <li>
                                <a
                                    href="https://www.plus.pl/strefa-dobrych-sprzetow/motorola"
                                    class="flex h-12 items-center justify-center border border-[#eee] p-2"
                                >
                                    <img
                                        src="https://api.plus.pl/jcr/files/file/adp/files/images_lp/plus/strefa-dobrych-sprzetow/Motorola_new_logo.svg"
                                        alt="Motorola logo"
                                        loading="lazy"
                                    />
                                </a>
                            </li>
                        </ul>

                        <a
                            href="https://www.plus.pl/pluswymiana"
                            class="flex items-center justify-center"
                        >
                            <img
                                src="https://api.plus.pl/file/files/file/images_lp/plus/bannery/menu.webp"
                                alt="Banner iPhone 15 w Programie Plus Wymiana. Teraz za jedyne 3166 zł"
                                loading="lazy"
                            />
                        </a>
                    </div>
                </div>
            </div>

            <!-- ZAKŁADKA: OBSŁUGA KLIENTA -->
            <div
                id="expanded-menu-clients"
                class="absolute inset-x-0 z-[500] hidden min-h-[400px] bg-white py-6 shadow-[0px_3px_26px_rgba(0,0,0,0.1019607843)]"
            >
                <div class="mx-auto grid max-w-screen-xl grid-cols-4 gap-6 px-3 pb-4">
                    <div>
                        <p class="mb-4">
                            <strong>Informacyjne:</strong>
                        </p>
                        <ul class="grid gap-2 font-semibold">
                            <li><a href="https://www.plus.pl/kontakt">Kontakt i informacje</a></li>
                            <li><a href="https://www.plus.pl/pomoc-faq">Pomoc i FAQ</a></li>
                            <li><a href="https://www.plus.pl/5g">5G w Plusie</a></li>
                            <li><a href="https://www.plus.pl/mapa-zasiegu">Mapa zasięgu</a></li>
                            <li><a href="https://www.plus.pl/przenies-numer">Przeniesienie numeru</a></li>
                            <li><a href="https://www.plus.pl/uslugi/platnosci">Faktury i formy płatności</a></li>
                            <li><a href="https://www.plus.pl/speedtest">Sprawdź prędkość internetu</a></li>
                            <li><a href="https://www.plus.pl/zwroty">Darmowe zwroty</a></li>
                        </ul>
                    </div>

                    <div>
                        <p class="mb-4">
                            <strong>Dla obecnych klientów:</strong>
                        </p>
                        <ul class="grid gap-2 font-semibold">
                            <li><a href="https://www.plus.pl/abonament/przedluz-umowe">Przedłuż umowę</a></li>
                            <li><a href="https://doladuj.plus.pl/doladowanie">Doładuj konto</a></li>
                            <li><a href="https://plus.pl/platnosc/">Opłać fakturę online</a></li>
                            <li>
                                <a href="https://www.plus.pl/uslugi/krotkie-kody-w-plusie-na-karte"
                                    >Krótkie kody (na kartę)</a
                                >
                            </li>
                            <li><a href="https://www.plus.pl/strefa-plusow">Bonusy i promocje</a></li>
                            <li><a href="https://www.plus.pl/abonament/zmien-umowe">Zyskaj więcej GB</a></li>
                        </ul>
                    </div>

                    <div>
                        <p class="mb-4">
                            <strong>iPlus:</strong>
                        </p>
                        <ul class="grid gap-2 font-semibold">
                            <li>
                                <a href="https://ssl.plusgsm.pl/ebok-web/basic/loginStep1.action?brandId=Postpaid"
                                    >Zaloguj się do iPlus</a
                                >
                            </li>
                            <li><a href="https://www.plus.pl/iplus">Co to jest iPlus?</a></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </header>
</template>

<style lang="scss" scoped>
a:hover,
button:hover {
    color: #35a735;
}

.liberty {
    background: #00283d;
    color: #fff;
    background-image: url(https://api.plus.pl/file/files/file/images_lp/plus/bannery/liberty/223231_1.webp);
    background-position-y: bottom;
    background-repeat: no-repeat;
    padding: 14px 8px 14px 84px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    text-align: left;
}

.liberty__sticker {
    position: absolute;
    top: 8px;
    left: 8px;
    border-radius: 2px;
    background: #ff5353;
    padding: 4px;
    font-size: 10px;
}

.liberty__btn {
    margin-left: 8px;
    background: #13fb76;
    color: #00283d;
    width: 36px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: icomoon;
    border-radius: 4px;
    transition: all 0.5s;
    border: none;
}

.liberty__btn:hover {
    scale: 1.1;
}

/* HAMBURDEG ICON */
.menu-icon {
    width: 40px;
    height: 30px;
    display: flex;
    align-items: center;
}

.menu-icon:hover {
    color: unset !important;
}

.menu-icon::before {
    content: '';
    top: 4px;
}
.menu-icon::after {
    content: '';
    bottom: 4px;
}

.menu-icon__line,
.menu-icon::before,
.menu-icon::after {
    width: 100%;
    height: 3px;
    background-color: #27a041;
    position: absolute;
    margin: auto;
    display: block;
    transition: all 0.1s ease-in-out;
}

.menu-icon__line.close,
.menu-icon::before.close,
.menu-icon::after.close {
    display: none;
}

.menu-icon.close {
    span.menu-icon__line {
        display: none !important;
    }
}

.menu-icon.close::before,
.menu-icon.close::after {
    top: 0;
    bottom: 0;
}
.menu-icon.close::before {
    transform: rotate(-45deg);
}
.menu-icon.close::after {
    transform: rotate(45deg);
}

/* MENU TRANSITIONS */
@keyframes slideFrom {
    from {
        transform: translateX(100%);
    }

    to {
        transform: translateX(0);
    }
}
@keyframes slideLeave {
    from {
        transform: translateX(0);
    }

    to {
        transform: translateX(-100%);
    }
}

/* MENU - BUTTON */
.menu_list {
}

.menu_item {
    border-top: 1px solid #eee;
}

.menu_item_child {
    padding: 16px 12px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.menu_back_btn {
    color: #024f27;
    background-color: #f2f2f2;
    width: 100%;
    text-align: left;
    font-weight: 600;
    font-size: 14px;
    padding: 8px 12px;
}

/* MENU - BUTTON */
.menu_list {
}

.menu_item {
    border-top: 1px solid #eee;
}

.menu_item_child {
    padding: 16px 12px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.menu_back_btn {
    color: #024f27;
    background-color: #f2f2f2;
    width: 100%;
    text-align: left;
    font-weight: 600;
    font-size: 14px;
    padding: 8px 12px;
}
</style>
